import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.5 19.25h-2.933a.275.275 0 0 1-.275-.276v-3.85a2.291 2.291 0 1 0-4.584 0v3.85a.275.275 0 0 1-.275.275H5.5q-2.75 0-2.75-2.75v-5.82c0-1.831.48-2.112 1.31-2.81l5.468-4.583a2.29 2.29 0 0 1 2.945 0L17.94 7.87c.83.697 1.31.978 1.31 2.81v5.82q0 2.75-2.75 2.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }